import axios from './axiosConfig'
import store from '@store'

export async function postRequest(route, payload) {
	const response = await axios({ 
		url: '/' + route, 
		data: payload,
		method: 'POST'
	});
	alertHandler(response);
	return response;
}
export async function getRequest(route, payload = null) {
	const response = await axios({ 
		url: '/' + route, 
		data: payload,
		method: 'GET'
	});
	alertHandler(response);
	return response;
}
export async function putRequest(route, payload) {
	const response = await axios({ 
		url: '/' + route, 
		data: payload,
		method: 'PUT'
	});
	alertHandler(response);
	return response;
}
export async function deleteRequest(route) {
	const response = await axios({ 
		url: '/' + route, 
		method: 'DELETE'
	});
	alertHandler(response);
	return response;
}

function alertHandler(response) {
	if(!response.headers.hasOwnProperty('type') ||  !response.headers.hasOwnProperty('message')) {
		return;
	}
	store.dispatch('alert/setAlert', {type: response.headers.type, message: Lang(response.headers.message)})
}
